import script from "./PayoffForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./PayoffForm.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/css/loans/form.css?vue&type=style&index=0&id=ce6deb1c&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce6deb1c"]])

export default __exports__